import React, { useState, createContext, Dispatch, SetStateAction, useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import MainPage from './components/MainPage';
import AdminLogin from './components/AdminLogin';
// import Helmet from 'react-helmet';  

import './App.css';

const msgList: any[] = [];
const setFunc: Dispatch<SetStateAction<any[]>> = () => {}
const language: string = 'pt';
const setLanguage: Dispatch<SetStateAction<string>> = () => {}
export const appContext = createContext({
   messages: msgList, 
   setMessages: setFunc,
   language,
   setLanguage
});

function App() {

   const [messages, setMessages] = useState<any[]>([]);
   const [language, setLanguage] = useState<string>('');

   useEffect(() => {
      const storageLang = localStorage.getItem('language');
      if (storageLang) setLanguage(storageLang);
   }, []);

   useEffect(() => {
      localStorage.setItem('language', language);
   }, [language]);


   

   return (
      <div className="App">
         {/* <Helmet>
            <meta
               name="description"
               content=""
            />
         </Helmet> */}
         <div className='app-overlay d-flex justify-content-center w-100 h-100'>
            <div>
               <Navbar />
               <BrowserRouter>
                  <Switch>
                     <appContext.Provider value={{messages, setMessages, language, setLanguage}}>
                        <Route exact path='/' component={MainPage}></Route>
                        <Route exact path='/admin' component={AdminLogin}></Route>
                     </appContext.Provider>
                  </Switch>
               </BrowserRouter>
            </div>
         </div>
      </div>
   );
}

export default App;
